// controllers/color_input_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "swatch"];

  connect() {
    this.updateSwatch();
  }

  updateSwatch() {
    const color = this.normalizeColor(this.inputTarget.value.trim());

    if (!color) {
      this.swatchTarget.style.backgroundColor = "";
      return;
    }

    if (this.isValidColor(color)) {
      this.inputTarget.value = color;
      this.swatchTarget.style.backgroundColor = color;
      this.swatchTarget.hidden = false;
    } else {
      this.swatchTarget.style.backgroundColor = "";
    }
  }

  // Prepends # if the value looks like a hex color missing its leading #
  normalizeColor(color) {
    if (/^[0-9a-fA-F]{3}$|^[0-9a-fA-F]{6}$/.test(color)) {
      return `#${color}`;
    }
    return color;
  }

  validate() {
    const color = this.inputTarget.value.trim();

    if (!color) return;


    this.errorTarget.hidden = this.isValidColor(color);
  }

  isValidColor(color) {
    const el = document.createElement("div");
    el.style.color = "";
    el.style.color = color;

    const isValid = el.style.color !== "";

    // Clean up the element to avoid memory leaks
    el.remove();

    return isValid;
  }
}

